import React, { useContext, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { CaretDown as CaretDownIcon } from '@phosphor-icons/react/dist/ssr/CaretDown';
import { CaretRight as CaretRightIcon } from '@phosphor-icons/react/dist/ssr/CaretRight';
import Collapse from '@mui/material/Collapse';
import DataContext from '@/contexts/DataContext';
import { icons } from '@/components/dashboard/layout/nav-icons';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { logger } from '@/lib/default-logger';

const testItems = [1, 2, 3, 4]

/**
 * Similar to DetailListExpandable
 * Basically a card header with a link to a page
 * @param {*} param0 
 * @returns 
 */
export function DetailCard({config = {}}) {
    const navigate = useNavigate();
    const HeaderIcon = icons[config.icon] || null; 
    const RightArrowIcon = icons['arrow-right'] ||  null; 
    const href = config.href || null;

    return (
    <Box sx={{ bgcolor: 'none', p: 1}}>
        <Link href={config.href ?? ''} style={{textDecoration: 'none', color: 'inherit'}}>
            <Card>
            <CardHeader 
                avatar={HeaderIcon ? <HeaderIcon /> : null} // throws error if we directly pass icons['iconName']
                title={config?.name || ""} 
                action={
                    <IconButton aria-label='collapse/expand button' onClick={() => {}}>
                        <RightArrowIcon />
                    </IconButton>
                }
                // onClick={() => {if (href) navigate(href);}}
            />
            </Card>
        </Link>
    </Box>
    );
}
